/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMetricContext } from './en-metric-context';
import { EnMetricDistrict } from './en-metric-district';
import { EnMetricMeasure } from './en-metric-measure';
import { EnMetricMovement } from './en-metric-movement';
import { EnMetricSide } from './en-metric-side';
 /**
 *
 *
 * @export
 * @interface StationMetricRequestDto
 */
export interface StationMetricRequestDto {

    /**
     * @type {string}
     * @memberof StationMetricRequestDto
     */
    from: string;

    /**
     * @type {string}
     * @memberof StationMetricRequestDto
     */
    to: string;

    /**
     * Filter by one or more measures.
     *
     * @type {Array<EnMetricMeasure>}
     * @memberof StationMetricRequestDto
     */
    measure?: Array<EnMetricMeasure>;

    /**
     * @type {Array<string>}
     * @memberof StationMetricRequestDto
     */
    aggregations: Array<StationMetricRequestDtoAggregationsEnum>;

    /**
     * @type {string}
     * @memberof StationMetricRequestDto
     */
    interval?: string;

    /**
     * @type {EnMetricContext}
     * @memberof StationMetricRequestDto
     */
    context?: EnMetricContext;

    /**
     * Filter by one or more anatomical districts.
     *
     * @type {Array<EnMetricDistrict>}
     * @memberof StationMetricRequestDto
     */
    district?: Array<EnMetricDistrict>;

    /**
     * Filter by body side.
     *
     * @type {EnMetricSide}
     * @memberof StationMetricRequestDto
     */
    side?: EnMetricSide;

    /**
     * Filter by one or more movement directions.
     *
     * @type {Array<EnMetricMovement>}
     * @memberof StationMetricRequestDto
     */
    movement?: Array<EnMetricMovement>;
}

/**
 * @export
 * @enum {string}
 */
export enum StationMetricRequestDtoAggregationsEnum {
    Max = 'max',
    Min = 'min',
    Sum = 'sum',
    Avg = 'avg',
    Std = 'std',
    Count = 'count'
}

